'use client'

import { cn } from '@/lib/utils'
import { useStoreI18n } from '@/store'
import { memo } from 'react'

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  children?: React.ReactNode
  size?: 's' | 'm'
  variant?: 'outline' | 'fill'
  status?: 'success' | 'error'
}

const StatusChip = ({
  children,
  size = 's',
  variant = 'fill',
  className,
  status = 'success',
  ...props
}: Props) => {
  const D = useStoreI18n.use.dictionary()

  const sizeClasses = {
    s: 'py-2xs px-sm',
    m: 'py-2xs px-sm'
  }

  const variantClasses = {
    fill: {
      success: 'bg-feedback-green text-neutral-100',
      error: 'bg-feedback-red text-neutral-100'
    },
    outline: {
      success: 'border border-neutral-300 text-feedback-green',
      error: 'border border-neutral-300 text-feedback-red'
    }
  }

  const textClass = cn(
    'relative leading-none flex items-center justify-center',
    size === 's' && 'textstyle-sm-button',
    size === 'm' && 'textstyle-md-button'
  )

  const classComposer = cn(
    sizeClasses[size],
    variantClasses[variant][status],
    textClass,
    className
  )

  return (
    <div {...props} className={classComposer}>
      {children ||
        (status === 'success' ? D['fe.plugin.open'] : D['fe.plugin.closed'])}
    </div>
  )
}

StatusChip.displayName = 'StatusChip'

export default memo(StatusChip)
